import { render, staticRenderFns } from "./warehouse-map.vue?vue&type=template&id=8ce707a2"
import script from "./warehouse-map.vue?vue&type=script&lang=js"
export * from "./warehouse-map.vue?vue&type=script&lang=js"
import style0 from "./warehouse-map.vue?vue&type=style&index=0&id=8ce707a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports